
import { Placement } from '@post-office/placements-frontend/confluence-sidenav-mpac-recommendations';
export default Placement;
